/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIMessage } from '@/models/api/message.model'

const resource = {
    main: 'services',
    module: 'messages'
}

export class MessagesServices {
    public static getMessages () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getMessagesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getMessagesById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createMessages (params: APIMessage) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editMessages (params: APIMessage) {
        return service.put(`${resource.main}/${resource.module}/${params.messageId}`, params)
    }

    public static deleteMessages (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreMessages (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
